module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjY4NyA1LjI0NjM0SDkuMDc4NTZMNy4zNDYyMSAwTDUuNjA4NDYgNS4yNDYzNEwwIDUuMjQxMDJMNC41NDE5OCA4LjQ4NjczTDIuODA0MjMgMTMuNzI3OEw3LjM0NjIxIDEwLjQ4NzRMMTEuODgyOCAxMy43Mjc4TDEwLjE1MDQgOC40ODY3M0wxNC42ODcgNS4yNDYzNFoiIGZpbGw9IiMwMEI2N0EiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./components/footer/assets/star.svg
// module id = 3hlY
// module chunks = 0